// PWA registration
export function registerPWA() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw-simple.js')
        .then((registration) => {
          console.log('PWA service worker registered:', registration);
        })
        .catch((error) => {
          console.log('PWA service worker registration failed:', error);
        });
    });
  }
}
